<template>
	<div>
		<bread-crumbs
			:title="$t('Follower.FollowersList')"
			:subTitle="$t('general.SubtitleTypeConfig')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		/>
		<vs-card>
			<div class="follower-list mt-4">
				<vs-table ref="table" search :data="getFollowers">
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
						<vs-dropdown
							v-if="getFollowers.length > 0"
							vs-trigger-click
							class="cursor-pointer mb-4 mr-4 items-per-page-handler"
						>
							<div
								class="
									p-4
									border border-solid
									d-theme-border-grey-light
									rounded-full
									d-theme-dark-bg
									cursor-pointer
									flex
									items-center
									justify-between
									font-medium
								"
							>
								<span class="mr-2"
									>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
									{{
										getFollowers.length - currentPage * itemsPerPage > 0
											? currentPage * itemsPerPage
											: getFollowers.length
									}}
									of {{ queriedItems }}</span
								>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>

							<vs-dropdown-menu>
								<vs-dropdown-item @click="itemsPerPage = 4">
									<span>4</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 10">
									<span>10</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 15">
									<span>15</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 20">
									<span>20</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>

					<template slot="thead">
						<vs-th>Id</vs-th>
						<vs-th>{{ $t("Schedule.Visit") }} Id</vs-th>
						<vs-th>{{ $t("Schedule.Visit") }}</vs-th>
						<vs-th>{{ $t("Email") }}</vs-th>
						<vs-th>{{ $t("Phone") }}</vs-th>
						<vs-th>{{ $t("Action") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td :data="tr.id">
								{{ tr.id }}
							</vs-td>
							<vs-td :data="tr.event_id">
								{{ tr.event_id }}
							</vs-td>
							<vs-td :data="tr.event_id">
								{{ resolveEventById(tr.event_id).activity_name | capitalize }}
								{{ resolveEventById(tr.event_id).date_prog }} -
								{{ resolveEventById(tr.event_id).init_hour }}
							</vs-td>
							<vs-td :data="tr.email">
								{{ tr.email.length > 0 ? tr.email.length : 0 }}
							</vs-td>
							<vs-td :data="tr.email">
								{{ tr.cell_phone.length > 0 ? tr.cell_phone.length : 0 }}
							</vs-td>

							<vs-td class="whitespace-no-wrap">
								<feather-icon
									icon="EditIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click="editData(tr)"
								/>
								<feather-icon
									icon="TrashIcon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click="openConfirm(tr)"
								/>

								<feather-icon
									icon="MoreVerticalIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									class="ml-2"
									@click="openPrompt(tr)"
								/>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
				<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
			</div>

			<vs-prompt
				:accept-text="$t('Accept')"
				:cancel-text="$t('Cancel')"
				:active.sync="activePrompt"
				:title="promptTitle | capitalize"
			>
				<div class="con-exemple-prompt" v-if="selected">
					<div class="con-expand-followers w-full">
						<div class="flex flex-col items-start justify-start p-2 gap-2">
							<p>
								{{ resolveEventById(selected.event_id).date_prog }}
							</p>
							<p>
								{{ resolveEventById(selected.event_id).init_hour }} -
								{{ resolveEventById(selected.event_id).end_hour }}
							</p>
							<p>{{ resolveEventById(selected.event_id).visit_point_name | capitalize }}</p>
						</div>
						<vs-list>
							<vs-list>
								<vs-list-header
									:title="$t('Follower.to_email')"
									v-if="selected.email.length"
								></vs-list-header>
								<vs-list-item
									v-for="(email, index) in selected.email"
									:key="email"
									icon-pack="feather"
									icon="icon-mail"
								>
									<template slot="title">
										<div class="ml-2 p-2">
											<p>{{ email }}</p>
										</div>
									</template>
								</vs-list-item>

								<vs-list-header
									:title="$t('Follower.cell_phone')"
									v-if="selected.cell_phone.length"
								></vs-list-header>
								<vs-list-item
									v-for="(phone, index) in selected.cell_phone"
									:key="phone"
									icon-pack="feather"
									icon="icon-phone"
								>
									<template slot="title">
										<div class="ml-2 p-2">
											<p>{{ phone }}</p>
										</div>
									</template>
								</vs-list-item>
							</vs-list>
						</vs-list>
					</div>
				</div>
			</vs-prompt>
		</vs-card>
	</div>
</template>

<script>
// Store
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import DateUtils from "@/helpers/DateUtils.js";
import Event from "@/models/Event";

export default {
	name: "FollowerList",
	data() {
		return {
			followers: [],
			selected: null,
			itemsPerPage: 10,
			queriedItems: 0,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			eventIds: [],
			activePrompt: false,
		};
	},

	computed: {
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},

		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},

		resolveEventById() {
			return (eventId) => {
				const cachedEvents = this.$store.getters["moduleSchedule/getCachedEvents"];
				const event = cachedEvents.find((event) => event.id === eventId);
				return event ? event : new Event({});
			};
		},

		promptTitle() {
			return this.selected ? this.resolveEventById(this.selected.event_id).activity_name : "";
		},

		getFollowers() {
			return this.$store.getters["moduleSchedule/getFollowers"];
		},
	},

	methods: {
		// component methods
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async fetchScheduleFollowers() {
			try {
				this.openLoading();
				const payload = {
					page: this.currentPageLocal,
					quantity: this.itemsPerPage,
					sort: "desc",
				};
				const response = await this.$store.dispatch("moduleSchedule/fetchScheduleFollowers", payload);
				if (response.status === 201) {
					this.followers = response.data.records;
					const event_ids = this.followers.map((follower) => follower.event_id);
					const uniqueEventIds = [...new Set(event_ids)];
					this.eventIds = uniqueEventIds;

					Object.assign(this.pagination, response.data.pagination);
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.closeLoading();
			}
		},

		async fetchEventById(eventIds) {
			try {
				const payload = {
					id: eventIds,
					init_date: "1990-01-01",
					end_date: DateUtils.toDefaultDateTime(new Date(), "YYYY-MM-DD"),
				};

				this.openLoading();
				const response = await this.$store.dispatch("moduleSchedule/fetchEventById", payload);

				if (response && response.length > 0) {
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.closeLoading();
			}
		},

		async deleteScheduleFollower(followerId) {
			try {
				this.openLoading();
				const response = await this.$store.dispatch("moduleSchedule/deleteScheduleFollower", followerId);
				if (response.status === 200) {
					this.$vs.notify({
						color: "success",
						title: this.$t("Waypoint.Waypoint"),
						text: this.$t("Record.TextConfirmRecordDelete"),
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.closeLoading();
			}
		},
		editData(tr) {
			this.$router.push({
				name: "calendar-follower-update",
				params: {event_id: tr.event_id, follower_id: tr.id},
			});
		},

		openConfirm(tr) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: `${this.$t("Record.DeleteRecord")}`,
				text: `${this.$t("Record.DeleteRecordConfirmText")} ${this.$t("Register")} ${tr.id}`,
				accept: () => this.deleteScheduleFollower(tr.id),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},

		openPrompt(tr) {
			this.selected = tr;
			this.activePrompt = true;
		},

		acceptAlert() {
			this.activePrompt = false;
			this.$vs.notify({
				color: "success",
				title: this.$t("Prompt.Accepted"),
				text: this.$t("Prompt.YouHaveAccepted"),
			});
		},
	},

	watch: {
		currentPage(val) {
			this.currentPageLocal = val;
			this.fetchScheduleFollowers();
		},

		itemsPerPage(val) {
			this.currentPageLocal = 1;
			this.fetchScheduleFollowers();
		},
		eventIds(val) {
			if (val.length > 0) {
				// check if almost one event id is not fetched yet and fetch it if necessary
				const cachedEvents = this.$store.getters["moduleSchedule/getCachedEvents"];
				const isCachedEvent = (eventId) => cachedEvents.some((event) => event.id === eventId);
				const every = val.every((eventId) => isCachedEvent(eventId));

				if (!every) {
					this.fetchEventById(val);
				}
			}
		},
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		this.fetchScheduleFollowers();
	},
};
</script>

<style lang="scss">
.follower-list {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
